import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  message,
  // Collapse,
  // List,
  Modal,
  Pagination,
  Popover,
  Table,
  Tooltip,
  // Typography,
} from "antd";
import { Splitter } from "antd";
import {
  ExpandOutlined,
  CompressOutlined,
  CloseOutlined,
  CheckOutlined,
  InfoCircleOutlined,
  FormOutlined,
  UserOutlined,
} from "@ant-design/icons";
import CommonTopDetails from "../CommonTopDetails";
import useCommonListing from "../customHooks/useCommonListing";
import { capitalizeWords } from "../../icons/ApplicationColor";
import {
  // GetFormattedDate,
  GetFormattedDateTime,
} from "../../utils/DateTimeUtils";
import axiosInstance from "../../../api/Axios";
import axios from "axios";

const BulkCourseUsersAdd = ({
  open,
  onClose,
  userInfo,
  course_id,
  LoadAPI,
  callMain,
  from = "course",
  course_ids = [],
  bundle_id = null,
  showMessage = false,
}) => {
  console.log(from, course_ids);
  const [fullscreen, setFullscreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys2, setSelectedRowKeys2] = useState([]);
  function formatTypeText(text) {
    if (!text) return "";
    // Replace underscores with spaces, lowercase everything, then capitalize each word
    return text
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }
  const columns2 = [
    {
      title: "User Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 200,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            src={record?.profile_pic || null}
            icon={!record?.profile_pic && <UserOutlined />}
            alt={record?.first_name}
            size="small"
          />
          <span>
            {record?.first_name} {record?.last_name}
          </span>
        </div>
      ),
    },
    {
      title: "Phone No.",
      dataIndex: "phone_number",
      key: "phone_number  ",
      width: 150,
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 220,
    },
    {
      title: capitalizeWords("Type"),
      dataIndex: "user_type",
      key: "user_type",
      width: 150, // set width to 150px
      render: (text) => formatTypeText(text),
    },
  ];

  const [combinedApiData, setCombinedApiData] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const exclude_bundle_course_id =
    from === "bundle"
      ? `exclude_bundle_id=${course_id}`
      : `exclude_course_id=${course_id}`;
  const {
    data: data2,
    itemsLength: itemsLength2,
    loading: loading2,
    filterData: filterData2,
    onShowSizeChange: onShowSizeChange2,
    onPageChange: onPageChange2,
    handleSearchChange: handleSearchChange2,
    // setFilterData: setFilterData2,
    // handleSwitchChange: handleSwitchChange2,
    // handleClearAll: handleClearAll2,
    // setFilterUrl: setFilterUrl2,
  } = useCommonListing({
    userInfo,
    passSize: 10,
    passPage: 1,
    passURL: `/user/?organization=${userInfo?.data?.organization?.id}&${exclude_bundle_course_id}&organization_user_archived=False`,
    takeFromData: (res) => res?.data?.data?.User_data,
    takeCountFrom: (res) => res?.data?.data?.paginator?.count,
    loadAgain: open,
    useOldPagination: true,
  });
  const {
    pageSize: pageSize2,
    currentPage: currentPage2,
    // active: active2,
    // filter_url: filter_url2,
  } = filterData2;

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const fetchCombinedData = async (organizationIds) => {
    setApiLoading(true);
    const payload = {
      assignments: organizationIds?.map((userId) => ({
        user: userId,
        assignments: [
          {
            course: Number(course_id),
            ass_type: "Course",
            ref_id: null,
          },
        ],
      })),
    };

    try {
      const response = await axiosInstance.post(
        "/learn/userstatuscheck/",
        payload,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      setCombinedApiData(response?.data?.data || []);
    } catch (error) {
      setCombinedApiData(null);
      // Optionally handle error
      console.error("Combined API error:", error);
    } finally {
      setApiLoading(false);
    }
  };
  const fetchCombinedDataCourse_IDS = async (organizationIds) => {
    setApiLoading(true);

    const payload = {
      assignments: organizationIds?.map((userId) => ({
        user: userId,
        assignments: course_ids?.map((cid) => ({
          course: Number(cid),
          ass_type: "Bundle",
          ref_id: bundle_id,
        })),
      })),
    };

    try {
      const response = await axiosInstance.post(
        "/learn/userstatuscheck/",
        payload,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      setCombinedApiData(response?.data?.data || []);
    } catch (error) {
      setCombinedApiData(null);
      console.error("Combined API error:", error);
    } finally {
      setApiLoading(false);
    }
  };

  useEffect(() => {
    if (selectedRowKeys2.length > 0) {
      if (from === "course") {
        fetchCombinedData(selectedRowKeys2);
      } else {
        fetchCombinedDataCourse_IDS(selectedRowKeys2);
      }
    } else {
      setCombinedApiData(null);
    }
    // eslint-disable-next-line
  }, [selectedRowKeys2]);

  const rowSelection2 = {
    selectedRowKeys: selectedRowKeys2,
    onChange: (newSelectedKeys, newSelectedRows) => {
      // Get all keys visible on current page
      const currentPageKeys = data2.map((row) => row.id || row.client_id);

      // Create a Set from current selections
      const updatedKeysSet = new Set(selectedRowKeys2);

      // Remove any deselected keys from current page
      currentPageKeys.forEach((key) => {
        updatedKeysSet.delete(key);
      });

      // Add all newly selected keys
      newSelectedKeys.forEach((key) => {
        updatedKeysSet.add(key);
      });

      // Final merged keys
      const finalKeys = Array.from(updatedKeysSet);
      setSelectedRowKeys2(finalKeys);
    },
  };

  // When combinedApiData changes, auto-select unassigned rows
  useEffect(() => {
    if (combinedApiData && combinedApiData.length > 0) {
      const autoSelected = combinedApiData
        .filter((row) => row.assigned_status === false)
        .map((row) => `${row.course_id}_${row.organization_id}`);
      setSelectedCombinedRowKeys(autoSelected);
    } else {
      setSelectedCombinedRowKeys([]);
    }
  }, [combinedApiData]);
  const renderStatus = (text, record) => {
    if (!text) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Popover
            title="Already Assigned"
            content={
              <div>
                <div>
                  <InfoCircleOutlined
                    style={{ color: "#1890ff", marginRight: 4 }}
                  />
                  <span style={{ color: "gray" }}>Message :</span>{" "}
                  {record.Message}
                </div>
                <div>
                  <span style={{ color: "gray" }}>Assigned At:</span>{" "}
                  {record.assigned_at
                    ? GetFormattedDateTime(record.assigned_at, true)
                    : "-"}
                </div>
              </div>
            }
          >
            <div
              style={{
                width: "1.8rem",
                height: "1.8rem",
                borderRadius: "50%",
                backgroundColor: "#ff4d4f",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CloseOutlined
                style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
              />
            </div>
          </Popover>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };

  const mergedCourses = {};

  combinedApiData?.forEach((item) => {
    const key = item.course_name;
    if (!mergedCourses[key]) {
      mergedCourses[key] = 0;
    }
    mergedCourses[key]++;
  });
  const combinedApiDataWithKeys = (combinedApiData || []).map((row, index) => ({
    ...row,
    key: index,
  }));
  const [selectedCombinedRowKeys, setSelectedCombinedRowKeys] = useState(
    combinedApiDataWithKeys?.map((item) => item.key) || []
  );

  useEffect(() => {
    if (combinedApiDataWithKeys?.length > 0) {
      setSelectedCombinedRowKeys(
        combinedApiDataWithKeys.map((item) => item.key)
      );
    }
  }, [combinedApiDataWithKeys]);
  const combinedColumns = [
    {
      title: "Course Name",
      dataIndex: "course_name",
      key: "course_name",
      // render: (text, row, index) => {
      //   const courseName = row.course_name;
      //   const firstOccurrence = combinedApiData.findIndex(
      //     (item) => item.course_name === courseName
      //   );

      //   if (index === firstOccurrence) {
      //     return {
      //       children: text,
      //       props: {
      //         rowSpan: mergedCourses[courseName],
      //       },
      //     };
      //   } else {
      //     return {
      //       children: null,
      //       props: {
      //         rowSpan: 0,
      //       },
      //     };
      //   }
      // },
    },
    {
      title: "User Name",
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: "Assignment Eligibility",
      dataIndex: "assigned",
      key: "assigned",
      render: renderStatus,
      width: 200,
      align: "center",
    },
  ];

  const combinedRowSelection = {
    selectedRowKeys: selectedCombinedRowKeys,
    onChange: setSelectedCombinedRowKeys,
    getCheckboxProps: (record, idx) => ({
      disabled: record.assigned_status === true,
    }),
  };
  const handleClose = () => {
    setFullscreen(false);
    setSelectedRowKeys2([]);
    setCombinedApiData([]);
    setSelectedCombinedRowKeys([]);
    setApiLoading(false);
    onClose();
  };

  console.log(userInfo);
  const submitData = async () => {
    setLoading(true);
    const selectedRows = combinedApiDataWithKeys.filter((row) =>
      selectedCombinedRowKeys.includes(row.key)
    );

    const payload = {
      assignments: selectedRows?.map((row) => ({
        user: row?.user_id,
        assignments: [
          {
            course: Number(course_id),
            ass_type: "Course",
            ref_id: bundle_id,
          },
        ],
      })),
      assignedBy: userInfo?.data?.id,
      tenantID: userInfo?.data?.organization?.id,
      applicationID: 5,
      dueDate: null,
    };
    const IdPayload = {
      assignments: Object.values(
        selectedRows.reduce((acc, row) => {
          const userId = row.user_id;

          if (!acc[userId]) {
            acc[userId] = {
              user: userId,
              assignments: [],
            };
          }

          course_ids.forEach((cid) => {
            if (
              !acc[userId].assignments.some((a) => a.course === Number(cid))
            ) {
              acc[userId].assignments.push({
                course: Number(cid),
                ass_type: "Bundle",
                ref_id: bundle_id,
              });
            }
          });

          return acc;
        }, {})
      ),
      assignedBy: userInfo?.data?.id,
      tenantID: userInfo?.data?.organization?.id,
      applicationID: 5,
      dueDate: null,
    };

    console.log(payload, IdPayload, combinedApiDataWithKeys, selectedRows);
    try {
      await axios.post(
        "https://newlms-api.trainery.one/api/client/users/assign-course",
        from === "course" ? payload : IdPayload,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      message.success("Bulk assignment successful!");
      LoadAPI();
    } catch (error) {
      message.error("Bulk assignment failed. Please try again.");
    } finally {
      setLoading(false);
      callMain();
      handleClose();
    }
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 18 }}>Bulk Actions</span>
        </div>
      }
      width={fullscreen ? "100vw" : 1300}
      style={fullscreen ? { top: 0, padding: 0, height: "100vh" } : {}}
      styles={{
        body: fullscreen
          ? { height: "calc(100vh - 100px)", overflow: "auto", padding: 0 }
          : { maxHeight: 800, overflow: "auto", padding: 0 },
      }}
      closeIcon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            marginRight: 40,
          }}
        >
          <Tooltip title={fullscreen ? "Exit Fullscreen" : "Expand"}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: fullscreen ? "#f0f0f0" : "transparent",
                boxShadow: fullscreen ? "0 0 4px #ccc" : "none",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setFullscreen((prev) => !prev);
              }}
            >
              {fullscreen ? <CompressOutlined /> : <ExpandOutlined />}
            </span>
          </Tooltip>
          <Tooltip title="Close">
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: "#f0f0f0",
                boxShadow: "0 0 4px #ccc",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
              }}
            >
              <CloseOutlined />
            </span>
          </Tooltip>
        </div>
      }
    >
      <div
        style={{
          width: "100%",
          // height: fullscreen ? "calc(100vh - 100px)" : 600,
          overflow: "hidden",
        }}
      >
        <Splitter style={{ width: "100%" }}>
          <Splitter.Panel
            defaultSize="100%"
            min="20%"
            max="80%"
            className="table-wrapper"
            style={{ overflowX: "auto", overflowY: "hidden" }}
          >
            <CommonTopDetails
              title={"Select Available Users"}
              titleSuffix={`${itemsLength2 || 0} user(s)`}
              searchPlaceholder="Search by ID or Title"
              searchAction={handleSearchChange2}
              marginPass="15px"
              paddingInlinepass="10px"
              showAddButton={false}
              filterAction={false}
              filterUrl={false}
            />
            <Table
              columns={columns2}
              dataSource={data2}
              size="small"
              bordered
              rowKey="id"
              className="table-container"
              scroll={{
                x: 200,
                y: fullscreen ? 500 : 400,
              }}
              style={{ marginInline: "1rem" }}
              pagination={false}
              loading={loading2}
              rowSelection={rowSelection2}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <Pagination
                size="small"
                showSizeChanger
                onShowSizeChange={onShowSizeChange2}
                onChange={onPageChange2}
                pageSizeOptions={["5", "10", "15", "30", "50", "100"]}
                current={currentPage2}
                defaultPageSize={pageSize2}
                total={itemsLength2}
              />
            </div>
          </Splitter.Panel>
        </Splitter>
        {combinedApiData?.length > 0 && (
          <div style={{ marginTop: 22 }}>
            <h5 style={{ fontWeight: 500, fontSize: 16, marginBottom: 16 }}>
              <span
                role="img"
                aria-label="link"
                style={{ marginRight: 8, color: "#1890ff" }}
              >
                🔗
              </span>
              Combined Selection
            </h5>
            <Table
              columns={combinedColumns}
              scroll={{
                x: 200,
                y: fullscreen ? "calc(100vh - 160px)" : 430,
              }}
              dataSource={combinedApiDataWithKeys}
              className="table-container"
              size="small"
              bordered
              rowSelection={combinedRowSelection}
              pagination={false}
              rowKey="key"
              loading={apiLoading}
              style={{
                marginInline: "1rem",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                margin: "3rem",
                marginInline: "2rem",
                marginBottom: "1rem",
              }}
            >
              <Button
                key="back"
                onClick={(e) => {
                  e.stopPropagation();
                  handleClose();
                }}
                style={{ marginRight: "1rem" }}
              >
                <CloseOutlined />
                Cancel
              </Button>

              <Button
                type="primary"
                htmlType="submit"
                onClick={submitData}
                disabled={selectedCombinedRowKeys.length === 0}
                loading={loading}
              >
                Save Assignment{combinedApiData.length > 1 ? "s" : ""}
                <FormOutlined />
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default BulkCourseUsersAdd;
